import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { AgrPrintPageModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

import { AlvaMetricsDto } from 'src/app/insemination-advice/models/alva-metrics.model';

import { InseminationPrintRow } from '../../../models/insemination-advice.model';

@Component({
  selector: 'insemination-print',
  templateUrl: './insemination-print.component.html',
  styleUrls: ['./insemination-print.component.scss'],
  standalone: true,
  imports: [CommonModule, AgrPrintPageModule, AgrI18nSharedModule],
})
export class InseminationPrintComponent {
  @Input() printTableData: InseminationPrintRow[] = [];
  @Input() measurementDate: Date | null = null;
  @Input() alvaMetrics: AlvaMetricsDto | null = null;

  showLogo = true;

  onLogoError(): void {
    this.showLogo = false;
  }

  // Template bindings
  printTableDataFn(): InseminationPrintRow[] {
    return this.printTableData ?? [];
  }

  measurementDateFn(): Date {
    return this.measurementDate ?? new Date();
  }
}
